import InsertEdgeBase from './InsertEdgeBase';
import { EdgeProps, getSmoothStepPath } from '@xyflow/react';

export default function InsertEdgeSmooth(props: EdgeProps) {
  return <InsertEdgeBase {...props} getPath={getSmoothStepPath} />;
}
